// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { showFullDay, showWorkDay, messages } from '../../../messages/main';
import { ToolbarItem } from '@progress/kendo-vue-buttons';
import { getDefaultSlots } from '@progress/kendo-vue-common';
import { Button } from '@progress/kendo-vue-buttons';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { clockIcon } from '@progress/kendo-svg-icons';
/**
 * @hidden
 */
var BusinessHoursVue2 = {
  name: 'KendoBusinessHours',
  // @ts-ignore
  emits: {
    click: null
  },
  inject: {
    ks: {
      default: null
    },
    kendoLocalizationService: {
      default: null
    }
  },
  props: {
    slotDuration: Number
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    this.localization = provideLocalizationService(this);
    return this.slotDuration && this.slotDuration < 24 * 60 ?
    // @ts-ignore  function children
    h(ToolbarItem
    // ref={(item) => { if (item) { element.current = item.element; } }}
    , {
      "class": 'k-scheduler-navigation'
    }, this.v3 ? function () {
      return [defaultSlot ? defaultSlot :
      // @ts-ignore  function children
      h(Button, {
        tabIndex: -1,
        attrs: _this.v3 ? undefined : {
          tabIndex: -1,
          icon: 'clock',
          svgIcon: clockIcon
        },
        icon: 'clock',
        svgIcon: clockIcon,
        onClick: _this.handleShowWorkHoursClick,
        on: _this.v3 ? undefined : {
          "click": _this.handleShowWorkHoursClick
        }
      }, _this.v3 ? function () {
        return [_this.localization.toLanguageString(_this.ks.showWorkHours ? showFullDay : showWorkDay, messages[_this.ks.showWorkHours ? showFullDay : showWorkDay])];
      } : [_this.localization.toLanguageString(_this.ks.showWorkHours ? showFullDay : showWorkDay, messages[_this.ks.showWorkHours ? showFullDay : showWorkDay])])];
    } : [defaultSlot ? defaultSlot : h(Button, {
      tabIndex: -1,
      attrs: _this.v3 ? undefined : {
        tabIndex: -1,
        icon: 'clock',
        svgIcon: clockIcon
      },
      icon: 'clock',
      svgIcon: clockIcon,
      onClick: _this.handleShowWorkHoursClick,
      on: _this.v3 ? undefined : {
        "click": _this.handleShowWorkHoursClick
      }
    }, _this.v3 ? function () {
      return [_this.localization.toLanguageString(_this.ks.showWorkHours ? showFullDay : showWorkDay, messages[_this.ks.showWorkHours ? showFullDay : showWorkDay])];
    } : [_this.localization.toLanguageString(_this.ks.showWorkHours ? showFullDay : showWorkDay, messages[_this.ks.showWorkHours ? showFullDay : showWorkDay])])]) : null;
  },
  methods: {
    handleShowWorkHoursClick: function handleShowWorkHoursClick(e) {
      this.$emit('click', e);
    }
  }
};
/**
 * @hidden
 */
var BusinessHours = BusinessHoursVue2;
export { BusinessHours, BusinessHoursVue2 };